import getYDocFromSafeSpace from './getYDocFromSafeSpace';
import { SafeSpace } from '../types';

export default function transactInSpace(space: SafeSpace, cb: () => void, origin?: any) {
    const yDoc = getYDocFromSafeSpace(space);
    yDoc.transact(() => {
        cb();
    }, origin);
}
